import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";

export const submitCampaignDesign = createAsyncThunk(
    "campaignDesign/submit",
    async (formData, thunkAPI) => {
        try {
            const response = await axios.post(
                `${baseURL}/campaign-design`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return response.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const fetchCampaignDesigns = createAsyncThunk(
    "campaignDesign/fetchAll",
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(
                `${baseURL}/campaign-designs`,
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                    },
                }
            );
            return response.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || err.message);
        }
    }
);

const CampaignDesignSlice = createSlice({
    name: "campaignDesign",
    initialState: {
        // Submit state
        loading: false,
        success: false,
        error: null,
        data: null,
        // Fetch state
        designs: [],
        fetchLoading: false,
        fetchError: null,
        assignLoading: false,
        assignSuccess: false,
        assignError: null,
    },
    reducers: {
        resetState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Submit cases
            .addCase(submitCampaignDesign.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(submitCampaignDesign.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.success = true;
                state.data = payload;
            })
            .addCase(submitCampaignDesign.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            // Fetch cases
            .addCase(fetchCampaignDesigns.pending, (state) => {
                state.fetchLoading = true;
                state.fetchError = null;
            })
            .addCase(fetchCampaignDesigns.fulfilled, (state, { payload }) => {
                state.fetchLoading = false;
                state.designs = payload;
            })
            .addCase(fetchCampaignDesigns.rejected, (state, { payload }) => {
                state.fetchLoading = false;
                state.fetchError = payload;
            })
            .addCase(assignDesigner.pending, (state) => {
                state.assignLoading = true;
                state.assignError = null;
                state.assignSuccess = false;
            })
            .addCase(assignDesigner.fulfilled, (state) => {
                state.assignLoading = false;
                state.assignSuccess = true;
            })
            .addCase(assignDesigner.rejected, (state, { payload }) => {
                state.assignLoading = false;
                state.assignError = payload;
            });
    },
});

export const assignDesigner = createAsyncThunk(
    "campaignDesign/assignDesigner",
    async (payload, thunkAPI) => {
        try {
            const response = await axios.post(
                `${baseURL}/assign-designer`,
                payload,
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const { resetState } = CampaignDesignSlice.actions;
export default CampaignDesignSlice.reducer;